<div class="utf-no-verification-required-container" id="utf-no-verification-required-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/NoVerificationRequired.png">
    <img id="verification-pending-icon" src="assets/images/NoVerificationRequired.png" alt="Review icon" tabindex="0">
  </picture>

  <div class="row no-gutters" id="no-verification-required-content">
    <div class="col-md-12">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="no-verification-required-heading" tabindex="0">
        {{cfetLabels.utf_verification_information.noverification_required_heading}}</h2>
      <p id="no-verification-required-desc" tabindex="0">
        {{cfetLabels.utf_verification_information.noverification_required_desc}}
      </p>
      <!--<p id="subDesc" tabindex="0">{{cfetLabels.utf_verification_information.noverification_required_subDesc}}</p>-->
      <ul>
        <li [innerHTML]="cfetLabels.utf_verification_information.noverification_required_desc2"></li>
        <li [innerHTML]="cfetLabels.utf_verification_information.noverification_required_desc3"></li>
      </ul>
      <p tabindex="0">{{cfetLabels.utf_verification_information.noverification_required_desc4}}</p>
      <p tabindex="0" [innerHTML]="cfetLabels.utf_verification_information.noverification_required_desc5"></p>
    </div>

    <hr>

    <div class="col-md-12 btn-container" id="no-verification-required-footer-column">
      <a data-dismiss="modal" tabindex="0" type="button" id="cancel_link"
        class="btn btn-secondary btn-clear cancel_link" (click)="cancelCreation($event)"
        (keyup)="cancelCreation($event)"><em aria-label=""></em>
        {{cfetButtonLabels.button_labels.cancel}}</a>
      <button tabindex="0" type="button" id="btn-continue" class="btn btn-alt btn-medium"
        (click)="completeProfile($event)" (keyup)="completeProfile($event)">
        {{cfetButtonLabels.button_labels.completeProfile}}</button>
    </div>
  </div>
</div>